

exports.__esModule = true;
exports.$xoSidebarAddBankPageComponent = undefined;

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

require('components/xo-wallet-components/src/add-bank/directive');

require('components/xo-page-components/src/aside-header/directive');

require('components/xo-validation/dist/directive');

require('components/xo-ui-components/src/tooltip/directive');

require('components/xo-ui-components/src/dropdown/directive');

var _squid = require('squid');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoSidebarAddBankPageComponent = exports.$xoSidebarAddBankPageComponent = _squid.$Component.extend('$xoSidebarAddBankPageComponent', {
    tag: 'xo-sidebar-add-bank-page',
    template: _template2['default'],

    controller: function controller($scope, $rootScope, $state) {
        // eslint-disable-line no-shadow
        $scope.sidebar = true;
        $scope.token = $rootScope.token;
        $scope.message = {};
        $scope.callbacks = {
            done: function done() {
                $state.go('checkout.review');
            }
        };
    }
});

angular.value("$xoSidebarAddBankPageComponent", $xoSidebarAddBankPageComponent);
_squid.$Component;


/*****************
 ** WEBPACK FOOTER
 ** ./pages/xo-sidebar-add-bank/directive.js
 ** module id = 334
 ** module chunks = 1
 **/